import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Edit } from "lucide-react";
import { useTranslation } from "react-i18next";
import ToggleSwitch from "../../ui/ToggleSwitch";
import { useUpdateResource } from "../../../hooks/useUpdateResource";

interface Props {
  active: boolean;
  productId:number
  storeId?:number
}

const ProductDetailActiveAndEditBar: React.FC<Props> = ({ active,productId,storeId }) => {
  const { t } = useTranslation();
  const [isActive, setIsActive] = useState(active);

   const {updateResource} = useUpdateResource();
  
            async function handleChangeActive(){
              setIsActive(p=>!p);
              const endPoint = storeId ? `product/active/${productId}?storeId=${storeId}` : `product/active/${productId}`
              await  updateResource(endPoint, {}, storeId ? "admin" : "store",{
                  method: "PUT",
                  invalidateQueries:["product-detail"],
            });
            }

        const editLink = storeId ? `/admin/stores/${storeId}/update-product/${productId}` :`/store/update-product/${productId}` 

  return (
    <div className="flex justify-end p-4">
      <div className="flex items-center justify-between w-[500px] p-4 border rounded-lg bg-white shadow-sm">
        {/* Active Box */}
        <div className="flex items-center gap-4">
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <h3 className="font-semibold text-[14px] text-DarkGrey3">
                {isActive ? t("product_active") : t("product_inactive")}
              </h3>

              {/* Reusable Toggle */}
              <ToggleSwitch checked={isActive} onChange={handleChangeActive} size="md" />
            </div>

            <p className="text-sm text-DarkGrey3 text-[12px]">
              {isActive ? t("available_for_buy") : t("not_available_for_buy")}
            </p>
          </div>
        </div>

        {/* Edit Link */}
        <Link to={editLink} className="text-primaryButton font-medium hover:underline">
          <Edit />
        </Link>
      </div>
    </div>
  );
};

export default ProductDetailActiveAndEditBar;
